import { QuickActionButtons } from "./QuickActionButtons";

export default QuickActionButtons;
